<template>
  <div class="pvflex flex flex-row align-center justify-between w-full ym-bg-primary m-0 p-0 pl-2" style="max-height:64px;min-height:64px">
    <PVButton icon="material-icons menu" class="bg-transparent text-black" @click="appearanceStore.toggleDrawer(!appearanceStore.isDrawerOpen)"/>
    <PVButton v-if="authStore.isLoggedIn" label="Log Out" class="bg-primary text-primary-contrast p-button-text uppercase nowrap" severity="primary" icon="material-icons exit_to_app" @click="authStore.logout()"/>
  </div>
</template>

<script lang="ts">
import { useAppearanceStore } from '@/stores/appearance.js';
import { useAuthStore } from '@/stores/authentication.js';
import { defineComponent } from 'vue';

export default defineComponent({
  name: "ToolBar",
  setup() {
    const appearanceStore = useAppearanceStore();
    const authStore = useAuthStore();
    return { appearanceStore, authStore };
  }
});
</script>
